import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { ThemeProvider } from './contexts/ThemeContext';
import './App.css';
import LandingPage from './pages/LandingVanguard';
import Propuesta from './pages/Propuesta';
import Vehiculos from './pages/Vehiculos';
import VehiculoDetalle from './pages/VehiculoDetalle';
import AgendaService from './pages/AgendaService';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <Routes>
            {/* Landing page pública */}
            <Route path="/" element={<LandingPage />} />
            
            {/* Propuesta comercial */}
            <Route path="/propuesta" element={<Propuesta />} />
            
            {/* Catálogo de vehículos público */}
            <Route path="/vehiculos" element={<Vehiculos />} />
            <Route path="/vehiculos/:id" element={<VehiculoDetalle />} />

            {/* Agenda de service */}
            <Route path="/agendar" element={<AgendaService />} />
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;